import http from './service'
const api = {
  //登出登入
  getMsgCode: parms => {//获取图片验证码
    return http.get('user/center/getVerify', parms).then(res => res.data)
  },
  getCode: data => {//获取短信验证码
    return http.post('user/center/sendMsgCode', data).then(res => res.data)
  },
  login: data => {//登录
    return http.post('user/center/login', data).then(res => res.data)
  },
  logout: data => {//退出登录
    return http.post('user/home/logout', data).then(res => res.data)
  },
  //个人信息
  updatePassword: data => {//修改密码
    return http.post('user/home/updatePassword', data).then(res => res.data)
  },
  updateUserPhone: data => {//修改绑定电话
    return http.post('user/home/updateUserPhone', data).then(res => res.data)
  },
  getApiSecrect: params => {//获取秘钥
    return http.get('user/home/getApiSecrect', params).then(res => res.data)
  },
  getUserInfo: params => {//获取当前登录者信息
    return http.get('user/home/getUserInfo', params).then(res => res.data)
  },
  // installBalanceSizeWarn: data => {//设置预警
  //   return http.post('user/home/setBalanceSizeWarn', data).then(res => res.data)
  // },
  //签名
  autographList: data => {//签名列表
    return http.post('manager/sign/getSmsSignList', data).then(res => res.data)
  },
  addAutograph: data => {//添加签名
    return http.post('manager/sign/add', data).then(res => res.data)
  },
  reviseAutograph: data => {//修改签名
    return http.post('manager/sign/update', data).then(res => res.data)
  },
  delAutograph: data => {//删除签名
    return http.post('manager/sign/del', data).then(res => res.data)
  },
  upImg: data => {//上传证明
    return http.post('oss/getToken.do', data).then(res => res.data)
  },
  //短信
  getSmsMouldList: data => {//短信模板
    return http.post('manager/mould/getSmsMouldList', data).then(res => res.data)
  },
  addMessage: data => {//新增短信模板
    return http.post('manager/mould/add', data).then(res => res.data)
  },
  reviseMessage: data => {//新增短信模板
    return http.post('manager/mould/update', data).then(res => res.data)
  },
  delMessage: data => {//删除短信模板
    return http.post('manager/mould/del', data).then(res => res.data)
  },
  getRecordList: data => {//短信记录
    return http.post('manager/record/getRecordList', data).then(res => res.data)
  },
  getHandleSmsOrderList: data => {//短信记录
    return http.post('manager/record/getHandleSmsOrderList', data).then(res => res.data)
  },
  getSmsOrderList: data => {//短信记录
    return http.post('manager/record/getSmsOrderList', data).then(res => res.data)
  },
  exportExcel: data => {//短信记录
    return http.postFile('manager/record/exportExcelMarketSmsInfo', data).then(res => res.data)
  },
  ordersBackAccount: data => {//短信记录
    return http.post('manager/record/ordersBackAccount', data).then(res => res.data)
  },
  //客户
  getSysUserList: data => {//客户列表
    return http.post('user/home/getSysUserList', data).then(res => res.data)
  },
  addUser: data => {//客户列表
    return http.post('user/home/addUser', data).then(res => res.data)
  },
  updateUser: data => {//修改客户信息
    return http.post('user/home/updateUser', data).then(res => res.data)
  },
  updateUserPhone: data => {//修改客户绑定号码
    return http.post('user/home/updateUserPhone', data).then(res => res.data)
  },
  updateSmsBalanceSize: data => {//充值短信
    return http.post('user/home/updateSmsBalanceSize', data).then(res => res.data)
  },
  getBalanceChangeList: data => {//短信额度变动记录
    return http.post('manager/balance/getBalanceChangeList', data).then(res => res.data)
  },
  //通道
  getPlatformList: data => {//通道列表
    return http.post('manager/platformPass/getPlatformList', data).then(res => res.data)
  },
  Update: data => {//修改通道内容
    return http.post('manager/platformPass/update', data).then(res => res.data)
  },
}
export default api




// WEBPACK FOOTER //
// ./src/server/api.js